import React, { PropsWithChildren } from 'react';
import extendClassName from '../../../../../../lib/bemUtils/bem';
import { TooltipPlacement } from '../../../../../atoms/Tooltip';
import FormHelp from '../../FormHelp/FormHelp';
import { createDescribedById } from '../../FormLabel/utilities';

type FieldsetLegendProps = {
  className?: string;
  modifier?: string;
  id?: string;
  helpText?: string;
};

export function FieldsetLegend({
  children,
  className,
  helpText,
  id,
  modifier,
}: PropsWithChildren<FieldsetLegendProps>) {
  return (
    <legend className={extendClassName(className || 'form-fieldset__legend', modifier)}>
      <span className="form-fieldset__legend-title">
        {children}
        {helpText && id && (
          <FormHelp id={createDescribedById(id)} helpText={helpText} tooltipPlacement={TooltipPlacement.TOP} />
        )}
      </span>
    </legend>
  );
}
